import { ApplicationSettingsAction, ApplicationSettingsActionNames } from "./actions";
import { IApplicationSettings, IPlanLimits } from "./interfaces";

const initialPlanLimits: IPlanLimits = {
  maxTemplatesPerLicense: null,
  maxPaidAgents: null,
  maxTeams: null,
  maxMailboxes: null,
  maxReplyAddresses: null,
  maxEmailDomains: null,
  maxCustomFieldsActive: null,
  maxChildTicketsPerTicket: null,
  maxSubscriptionsPerSocket: null,
  maxWebpushSubscriptionsPerAgent: null,
  maxRulesActive: null,
  maxSharedMacros: null,
  maxPrivateMacrosPerAgent: null,
  maxContactForms: null,
};

// @ts-expect-error TS(2741): Property 'limits' is missing in type '{ webpushSub... Remove this comment to see the full error message
const initialState: IApplicationSettings = {
  webpushSubscriptions: {
    applicationServerKey: null,
  },
  defaultTemplate: {
    content: {
      text: null,
      html: null,
    },
  },
  defaultVisualTemplate: {
    content: {
      text: null,
      html: null,
      appearance: null,
    },
  },
  exampleTicket: null,
  auditLog: null,
  poweredBy: null,
  plans: {
    enterprise: initialPlanLimits,
    team: initialPlanLimits,
    business: initialPlanLimits,
  },
  detectedLanguages: {},
};

export const applicationSettingsReducer = (
  state: IApplicationSettings = initialState,
  action: ApplicationSettingsAction
): IApplicationSettings => {
  switch (action.type) {
    case ApplicationSettingsActionNames.FETCH_APPLICATION_SETTINGS_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
